import { BEGIN_LOAD_CONFIGURATION, END_LOAD_CONFIGURATION_SUCCESS, END_LOAD_CONFIGURATION_ERROR } from "./types";
import { AppDispatch } from "../store";
import * as Api from "./api";

export const loadConfiguration = () => async (dispatch: AppDispatch) => {
    dispatch({ type: BEGIN_LOAD_CONFIGURATION });
    try {
        const configuration = await Api.get();
        dispatch({ type: END_LOAD_CONFIGURATION_SUCCESS, configuration });
    } catch (error) {
        dispatch({ type: END_LOAD_CONFIGURATION_ERROR, error });
    }
};
